module.exports = __webpack_public_path__ + "a3b6edda5e1c492bc67537f517ef19ee.svg";